import {
  GlobalStyles,
  defaultTheme_default,
  init_defaultTheme,
  init_esm2 as init_esm,
  require_prop_types
} from "./chunk-LXPIB7J4.js";
import {
  require_jsx_runtime
} from "./chunk-KV7LZDKO.js";
import {
  _extends,
  init_extends
} from "./chunk-OPCEO46S.js";
import {
  require_react
} from "./chunk-KJIRP3BF.js";
import {
  __toESM
} from "./chunk-J43GMYXM.js";

// node_modules/.pnpm/@mui+material@5.10.8_af5ln35zuaotaffazii6n6bke4/node_modules/@mui/material/esm/GlobalStyles/GlobalStyles.js
init_extends();
var React = __toESM(require_react());
var import_prop_types = __toESM(require_prop_types());
init_esm();
init_defaultTheme();
var import_jsx_runtime = __toESM(require_jsx_runtime());
function GlobalStyles2(props) {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(GlobalStyles, _extends({}, props, {
    defaultTheme: defaultTheme_default
  }));
}
__vite_process_env_NODE_ENV !== "production" ? GlobalStyles2.propTypes = {
  styles: import_prop_types.default.oneOfType([import_prop_types.default.func, import_prop_types.default.number, import_prop_types.default.object, import_prop_types.default.shape({
    __emotion_styles: import_prop_types.default.any.isRequired
  }), import_prop_types.default.string, import_prop_types.default.bool])
} : void 0;
var GlobalStyles_default = GlobalStyles2;

export {
  GlobalStyles_default
};
//# sourceMappingURL=chunk-FJPLLIWK.js.map
